import copy from 'copy-to-clipboard';
import Swal from "sweetalert2";
import {errorHandler} from "./errorHandler";
import {responses} from "./responses";

window.errorHandler = errorHandler;
window.responses = responses;
window.Swal = Swal;

window.synergyApi=`https://lna.abc.co.zm/SynergyApi/api/v1/`
// window.synergyApi=`http://192.168.1.222:8181/SynergyApi/api/v1/`

window.copy = copy;